import HelpCircle from 'assets/svg/icons/HelpCircle';
import cn from 'classnames';
import AIToolConsentModal from 'components/molecules/AIToolConsentModal';
import { useState, type FC } from 'react';
import { useTranslation } from 'react-i18next';
import { InformationCircleIconOutline } from 'utils/icons';
import { useAIChatContext } from './AIChat.context';
import { Button } from 'components/atoms/Button';

type AIChatDataShareModalProps = {
  showIcon?: boolean;
  className?: string;
  title?: string;
};

const AIChatDataShareModal: FC<AIChatDataShareModalProps> = ({
  showIcon,
  className,
  title,
}) => {
  const { aiAgent } = useAIChatContext();
  const { t } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);

  if (aiAgent === 'email_writer') return null;

  return (
    <>
      <Button
        className={cn(
          'flex gap-1 hover:underline justify-center items-center text-primary-400 hover:text-primary-300 text-sm',
          { 'mx-auto': showIcon },
          className,
        )}
        asDefault
        onClick={() => setIsOpen(true)}
      >
        {showIcon && <InformationCircleIconOutline className="w-5" />}
        <span>{title || t('ai_bot.data_share.helper.title')}</span>
        {!showIcon && <HelpCircle className="w-5" />}
      </Button>

      <AIToolConsentModal isOpen={isOpen} onClose={() => setIsOpen(false)} />
    </>
  );
};

export default AIChatDataShareModal;
